enum WallDirection {
	Left,
	Right
}

export default WallDirection
